import React, { useState } from 'react'

import { Content, Header, HeaderBreadCrum, Layout } from '../../layouts/AuthenticatedLayout'
import { Card, IconButton, Tooltip, Typography } from '@material-ui/core'
import SideBar from '../../common/DashboadSideBar'
import withImmutablePropsToJS from 'with-immutable-props-to-js'
import PieChartCard from './PieChartCard'
import { FilterList, DeleteSweep, CloudDownload } from '@material-ui/icons'
import TreeMapChartCard from './TreeMapChartCard'
import BarChart from './BarChart'
import { FilterSelectStyles } from '../../../resources/styles/ServicesListStyles'
import DateRangePicker from '../../common/daterangepicker/DateRangePicker'
import { AppBar, Tabs, Tab } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { TextField } from '@material-ui/core' // Add this import

export const COLORS = [
	'#50ADF5', // azul
	'#FF7965', // coral
	'#FFCB45', // amarillo
	'#6877E5', // azul violeta
	'#6FB07F', // verde
	'#A47FFF', // morado
	'#FF9F40', // naranja
	'#4BC0C0', // turquesa
	'#F67070', // rojo suave
	'#9966FF', // violeta

	'#8DD776', // verde claro
	'#FFB6B9', // rosa
	'#36A2EB', // azul claro
	'#FF6384', // rosa fuerte
	'#FFCE56', // amarillo suave
	'#2EC4B6', // aqua
	'#E71D36', // rojo intenso
	'#9B5DE5', // púrpura
	'#F15BB5', // magenta
	'#00BBF9', // cyan

	'#00F5D4', // verde aqua
	'#FEE440', // amarillo vibrante
	'#F77F00', // naranja intenso
	'#D62828', // rojo oscuro
	'#3A86FF', // azul vivo
	'#8338EC', // violeta intenso
	'#FB5607', // naranja quemado
	'#06D6A0', // verde brillante
	'#EF476F', // rosa rojo
	'#118AB2', // azul petróleo

	'#073B4C', // azul oscuro
	'#FFD166', // amarillo crema
	'#CDB4DB', // lavanda
	'#FFC8DD', // rosa pastel
	'#BDE0FE', // azul pastel
	'#A3CEF1', // azul gris
	'#588157', // verde oliva
	'#BC6C25', // café
	'#6A0572', // morado oscuro
	'#3B1F2B' // vino
]

const buildModelsByYearTreemapSeries = (recordsByModelByYear = []) => {
	return recordsByModelByYear.map((yearItem) => ({
		text: yearItem.Year.toString(),
		value: yearItem.Total, // importante para el tamaño del año
		children: yearItem.Models.map((model, index) => ({
			text: model.Model,
			value: model.Total
		}))
	}))
}

const buildGaeTreemapByYearSeries = (records = []) => [
	{
		text: 'GAE',
		children: records.map((y) => ({
			text: y.Year.toString(),
			children: y.Gaes.map((g) => ({
				text: g.GAE,
				value: g.Total
			}))
		}))
	}
]

const buildSalesByYearSeries = (salesByMonth = []) => {
	const yearMap = {};
	salesByMonth.forEach(item => {
		const year = item.Year;
		yearMap[year] = (yearMap[year] || 0) + (item.SalesCount || 0);
	});
	return Object.entries(yearMap).map(([year, count], idx) => ({
		text: year,
		values: [count],
		identifier: year,
		backgroundColor: COLORS[idx % COLORS.length]
	}));
};

const buildSalesByMonthSeries = (salesByMonth = [], selectedYear) => {
	const filtered = salesByMonth.filter(item => String(item.Year) === String(selectedYear));
	return filtered.map((item, idx) => ({
		text: item.MonthName,
		values: [item.SalesCount || 0],
		identifier: item.Month,
		backgroundColor: COLORS[idx % COLORS.length]
	}));
};

const buildSalesByModelSeries = (salesByModel = []) => {
	return salesByModel.map((item, idx) => ({
		text: item.Model,
		values: [item.SalesCount],
		identifier: item.Model,
		backgroundColor: COLORS[idx % COLORS.length]
	}));
};

const buildSalesBySkuSeries = (salesBySku = []) => {
	return salesBySku.map((item, idx) => ({
		text: item.Sku,
		values: [item.SalesCount],
		identifier: item.Sku,
		backgroundColor: COLORS[idx % COLORS.length]
	}));
};

const IndexDesktopView = (props) => {
	const filterClasses = FilterSelectStyles();
	const {
		userProfile,
		onClickFilterChart,
		onClickSalesFilterChart,
		criticalComponentsDashboard,
		filters,
		onChangeLocation,
		onChangeFilterByYear,
		onChangeFilterByMonth,
		onChangeFilterByModel,
		onChangeFilterBySalesModel,
		onDeleteAllFilter,
		onDeleteAllSalesFilter,
		onChangeFilterByGae,
		onChangeFilterByNomSol,
		onChangeFilterByMaterialPt,
		onChangeFilterByFault,
		onChangeFilterByFailure,
		selectedDate,
		onDateChange,
		onDownloadFailureReport,
		onDownloadSalesReport,
		onDownloadComparativeReport,
		salesDashboard,
		salesDateRange,
		onSalesDateRangeChange,
		comparativeDateRange,
		onComparativeDateRangeChange,
		onDeleteAllComparativeFilter,
	} = props

	const [tabValue, setTabValue] = useState(0)
	const handleTabChange = (event, newValue) => {
		setTabValue(newValue)
	};

	const showYearChart = filters.year.length === 0
	const showMonthChart = filters.year.length > 0
	const seriesByYear =
		criticalComponentsDashboard?.RecordsByYear?.map((item, index) => ({
			text: item.Year.toString(),
			values: [item.Total],
			identifier: item.Year,
			backgroundColor: COLORS[index % COLORS.length]
		})) ?? []

	const seriesByModel =
		criticalComponentsDashboard?.RecordsByModel?.map((item, index) => ({
			text: item.Model,
			values: [item.Total],
			identifier: item.Model,
			backgroundColor: COLORS[index % COLORS.length]
		})) ?? []

	const modelsByYearTreemapData = buildModelsByYearTreemapSeries(criticalComponentsDashboard?.RecordsByModelByYear ?? [])
	const recordsByGaeByYear = buildGaeTreemapByYearSeries(criticalComponentsDashboard?.RecordsByGaeByYear ?? [])
	const seriesByMonth =
		criticalComponentsDashboard?.RecordsByMonth?.map((m, i) => ({
			text: m.MonthName,
			identifier: m.Month,
			values: [m.Total],
			backgroundColor: COLORS[i % COLORS.length]
		})) ?? []

	const seriesByNomSol =
		criticalComponentsDashboard?.RecordsByNameSol?.map((item, index) => ({
			text: item.Text,
			values: item.Values,
			identifier: item.Text,
			backgroundColor: COLORS[index % COLORS.length]
		})) ?? []

	// `item.Text` for material PT records is expected to be in the format "CODE - description".
	// We derive the identifier from the leading code part before the '-' while handling
	// cases where the expected delimiter or type may not be present.
	const seriesByMaterialPt =
		criticalComponentsDashboard?.RecordsByMaterialPt?.map((item, index) => {
			const code = item.Text.split('-')[0];
			const trimmedCode = code.replace(/^0+/, ''); // Remove leading zeroes
			const rest = item.Text.substring(code.length); // Keep the rest of the text
			return {
				text: trimmedCode + rest, // Use trimmed code in the label
				values: item.Values,
				identifier: code, // Keep identifier as original code (with zeroes)
				backgroundColor: COLORS[index % COLORS.length]
			};
		}) ?? []

	const seriesByFault =
		criticalComponentsDashboard?.RecordsByFault?.map((item, index) => ({
			text: item.Text,
			values: item.Values,
			identifier: item.Text,
			backgroundColor: COLORS[index % COLORS.length]
		})) ?? []

	const seriesByFailure =
		criticalComponentsDashboard?.RecordsByFailure?.map((item, index) => ({
			text: item.Text,
			values: item.Values,
			identifier: item.Text,
			backgroundColor: COLORS[index % COLORS.length]
		})) ?? []

	const salesByYearSeries = buildSalesByYearSeries(salesDashboard?.SalesByMonth);
	const selectedSalesYear = filters.year[0] || (salesByYearSeries[0] && salesByYearSeries[0].identifier);
	const salesByMonthSeries = buildSalesByMonthSeries(salesDashboard?.SalesByMonth, selectedSalesYear);
	const salesByModelSeries = buildSalesByModelSeries(salesDashboard?.SalesByModel);
	const salesBySkuSeries = buildSalesBySkuSeries(salesDashboard?.SalesBySku);
	const comparativeBySku = salesDashboard?.ComparativeBySku ?? [];

	const salesValues = comparativeBySku.map(item => item.Sales);
	const failuresValues = comparativeBySku.map(item => item.Failures);

	const comparativeBarSeries = [
		{ text: 'Sales', values: salesValues, backgroundColor: COLORS[0] },
		{ text: 'Failures', values: failuresValues, backgroundColor: COLORS[1] }
	];

	const categories = comparativeBySku.map(item => item.Sku);

	const theme = useTheme();

	return (
		<Layout>
			{/* 🔵 HEADER AJUSTADO */}
			<Header
				key={'AuthenticatedHeader'}
				user={props.user}
				style={{ padding: '20px 30px' }}
				breadcrumbs={
					<HeaderBreadCrum>
						<Typography color='secondary'>Graphs</Typography>
					</HeaderBreadCrum>
				}
			/>

			<SideBar key={'AuthenticatedSideBar'} onChangeLocation={onChangeLocation} selectedButtonIndex={14} userProfile={userProfile} />

			{/* 🔵 PADDING PRINCIPAL AJUSTADO */}
			<Content key={'AuthenticatedContent'}>
				<div >
					<AppBar
						position="static"
						elevation={0}
						style={{
							background: theme.palette.background.paper,
							color: theme.palette.text.primary,
							borderBottom: `1px solid ${theme.palette.divider}`,
							boxShadow: 'none',
							marginBottom: 24,
						}}
					>
						<Tabs
							value={tabValue}
							onChange={handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							TabIndicatorProps={{
								style: { height: 4, borderRadius: 2 }
							}}
						>
							<Tab
								label={
									<Typography style={{ fontWeight: 600, fontSize: 16 }}>
										Failures
									</Typography>
								}
							/>
							<Tab
								label={
									<Typography style={{ fontWeight: 600, fontSize: 16 }}>
										Sales
									</Typography>
								}
							/>
							<Tab
								label={
									<Typography style={{ fontWeight: 600, fontSize: 16 }}>
										Comparative
									</Typography>
								}
							/>
						</Tabs>
					</AppBar>
					{tabValue === 0 && (
						<>
							{/* TÍTULO + DATE SELECTOR + FILTROS */}
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
								{/* Title */}
								<Typography color='primary' variant='h4' style={{ fontWeight: 600 }}>
									Charts
								</Typography>
								{/* DateSelector immediately to the right of the title */}
								<TextField
									label="Completion Date"
									type="date"
									value={selectedDate}
									onChange={onDateChange}
									InputLabelProps={{
										shrink: true,
									}}
									style={{ marginLeft: 24, marginRight: 'auto', minWidth: 180 }}
								/>
								{/* Buttons on the right */}
								<Tooltip title='Download report'>
									<IconButton onClick={onDownloadFailureReport}>
										<CloudDownload />
									</IconButton>
								</Tooltip>
								<Tooltip title='Clean filters'>
									<IconButton onClick={onDeleteAllFilter} className={filterClasses.iconDelete}>
										<DeleteSweep />
									</IconButton>
								</Tooltip>
								<Tooltip title='Filters'>
									<IconButton onClick={onClickFilterChart}>
										<FilterList />
									</IconButton>
								</Tooltip>
							</div>
							{/* 🔵 FILA DE 3 GRAFICAS */}
							<div style={{ display: 'flex', gap: 20, width: '100%' }}>
								{showYearChart && (
									<Card style={{ flex: 1, height: 500 }}>
										<PieChartCard
											title='Total Serial number year'
											series={seriesByYear}
											onSliceClick={onChangeFilterByYear}
											chartId='yearChart'
										/>
									</Card>
								)}

								{showMonthChart && (
									<Card style={{ flex: 1, height: 500 }}>
										<PieChartCard
											title={`Months of ${filters.year[0]}`}
											series={seriesByMonth}
											onSliceClick={onChangeFilterByMonth}
											chartId='monthChart'
										/>
									</Card>
								)}

								<Card style={{ flex: 1, maxWidth: '50%', minWidth: 300, height: 500 }}>
									<PieChartCard
										title='Total Models'
										subtitle='Sample Subtitle'
										mainColor='#D3D3D3'
										secondaryColor='#ADADAD'
										percentage={50}
										series={seriesByModel}
										onSliceClick={onChangeFilterByModel}
										chartId='modelChart'
									/>
								</Card>
							</div>

							<div style={{ display: 'flex', gap: 20, marginTop: 50 }}>
								<div style={{ flex: 1 }}>
									<TreeMapChartCard
										title='Total Models'
										subtitle='Sample Subtitle'
										chartId='chart3'
										series={modelsByYearTreemapData}
										onNodeClick={onChangeFilterByModel}
									/>
								</div>
							</div>
							<div style={{ display: 'flex', gap: 20, marginTop: 50 }}>
								<div style={{ flex: 1 }}>
									<TreeMapChartCard
										title='Total Models'
										subtitle='Sample Subtitle'
										chartId='chart4'
										series={recordsByGaeByYear}
										onNodeClick={onChangeFilterByGae}
									/>
								</div>
							</div>

							<div style={{ display: 'flex', gap: 20, marginTop: 50 }}>
								<div style={{ flex: 1 }}>
									<BarChart
										title='Total Applicant name'
										subtitle=''
										chartId='barChartjs'
										series={seriesByNomSol}
										onSliceClick={onChangeFilterByNomSol}
									/>
								</div>
							</div>
							{/* New BarChart for MaterialPt */}
							<div style={{ display: 'flex', gap: 20, marginTop: 50 }}>
								<div style={{ flex: 1 }}>
									<BarChart
										title='Total Material Pt'
										subtitle=''
										chartId='barChartMaterialPt'
										series={seriesByMaterialPt}
										onSliceClick={onChangeFilterByMaterialPt}
									/>
								</div>
							</div>
							{/* New BarChart for Fault */}
							<div style={{ display: 'flex', gap: 20, marginTop: 50 }}>
								<div style={{ flex: 1 }}>
									<BarChart
										title='Total Fault'
										subtitle=''
										chartId='barChartFault'
										series={seriesByFault}
										onSliceClick={onChangeFilterByFault}
									/>
								</div>
							</div>
							{/* New BarChart for Failure */}
							<div style={{ display: 'flex', gap: 20, marginTop: 50 }}>
								<div style={{ flex: 1 }}>
									<BarChart
										title='Total Failure'
										subtitle=''
										chartId='barChartFailure'
										series={seriesByFailure}
										onSliceClick={onChangeFilterByFailure}
									/>
								</div>
							</div>
						</>
					)}
					{tabValue === 1 && (
						<>
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
								<Typography color='primary' variant='h4' style={{ fontWeight: 600 }}>
									Sales
								</Typography>
								<div style={{ marginLeft: 24, marginRight: 'auto', maxWidth: 300 }}>
									<DateRangePicker
										startDate={salesDateRange.startDate}
										endDate={salesDateRange.endDate}
										onChangeRange={onSalesDateRangeChange}
									/>
								</div>
								<Tooltip title='Download report'>
									<IconButton onClick={onDownloadSalesReport}>
										<CloudDownload />
									</IconButton>
								</Tooltip>
								<Tooltip title='Clean sales filters'>
									<IconButton onClick={onDeleteAllSalesFilter} className={filterClasses.iconDelete}>
										<DeleteSweep />
									</IconButton>
								</Tooltip>
								<Tooltip title='Sales filters'>
									<IconButton onClick={onClickSalesFilterChart}>
										<FilterList />
									</IconButton>
								</Tooltip>
							</div>
							{/* SALES: FILA DE 3 GRAFICAS */}
							<div style={{ display: 'flex', gap: 20, width: '100%' }}>
								{showYearChart && (
									<Card style={{ flex: 1, height: 500 }}>
										<PieChartCard
											title='Sales by Year'
											series={salesByYearSeries}
											onSliceClick={onChangeFilterByYear}
											chartId='salesYearChart'
										/>
									</Card>
								)}
								{showMonthChart && (
									<Card style={{ flex: 1, height: 500 }}>
										<PieChartCard
											title={`Sales by Month${selectedSalesYear ? ` (${selectedSalesYear})` : ''}`}
											series={salesByMonthSeries}
											onSliceClick={onChangeFilterByMonth}
											chartId='salesMonthChart'
										/>
									</Card>
								)}
								<Card style={{ flex: 1, maxWidth: '50%', minWidth: 300, height: 500 }}>
									<PieChartCard
										title='Sales by Model'
										series={salesByModelSeries}
										onSliceClick={onChangeFilterBySalesModel}
										chartId='salesModelChart'
									/>
								</Card>
							</div>
							<div style={{ display: 'flex', gap: 20, marginTop: 50 }}>
								<div style={{ flex: 1 }}>
									<BarChart
										title='Sales by Sku'
										subtitle=''
										chartId='barChartSalesSku'
										series={salesBySkuSeries}
										onSliceClick={onChangeFilterByMaterialPt}
									/>
								</div>
							</div>
						</>
					)}
					{tabValue === 2 && (
						<>
							<div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
								<Typography color='primary' variant='h4' style={{ fontWeight: 600 }}>
									Comparative
								</Typography>
								<div style={{ marginLeft: 24, marginRight: 'auto', maxWidth: 300 }}>
									<DateRangePicker
										startDate={comparativeDateRange.startDate}
										endDate={comparativeDateRange.endDate}
										onChangeRange={onComparativeDateRangeChange}
									/>
								</div>
								<Tooltip title='Download report'>
									<IconButton onClick={onDownloadComparativeReport}>
										<CloudDownload />
									</IconButton>
								</Tooltip>
								<Tooltip title='Clean comparative filters' style={{ marginRight: 24 }}>
									<IconButton onClick={onDeleteAllComparativeFilter} className={filterClasses.iconDelete}>
										<DeleteSweep />
									</IconButton>
								</Tooltip>
							</div>
							<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
								<Card style={{ flex: 1, width: '100%', maxWidth: 1500, minWidth: 300 }}>
									<BarChart
										title='Sales vs Failures by Sku'
										subtitle=''
										chartId='barChartComparativeSku'
										series={comparativeBarSeries}
										categories={categories}
										onSliceClick={onChangeFilterByMaterialPt}
									/>
								</Card>
							</div>
						</>
					)}
				</div>
			</Content>
		</Layout>
	)
}

export default withImmutablePropsToJS(IndexDesktopView)
